/**
 * KeyboardCard — Settings → Company: the single-key shortcuts switch (Log
 * Activity slice C2, RULED 2026-10-09, Q1/Q2). WCAG 2.1.4 asks that a bare
 * letter shortcut can be turned off; this is the off switch. It is THIS
 * DEVICE's setting (browser storage through draftStorage's guard, keyed per
 * tenant and user), not the workspace's, and it says so. Default ON. With no
 * /v1/me identity yet it reads ON and writes nothing. A real switch role with
 * an accessible name and state, operable by keyboard as any button is.
 */
import { useState } from 'react'
import { cachedMeIdentity } from '../../api'
import { shortcutsPrefKey, readShortcutsEnabled, writeShortcutsEnabled } from '../../../../lib/shortcutsPref'

export const KEYBOARD_CARD_TITLE = 'Keyboard'
export const KEYBOARD_CARD_NOTE = 'Shortcuts that act on a single key. Saved on this device.'
export const SINGLE_KEY_LABEL = 'Single-key shortcuts'
export const SINGLE_KEY_HINT = 'L opens Log activity on any Sales page while you are not typing in a field.'

export function KeyboardCard() {
  const [key] = useState(() => shortcutsPrefKey(cachedMeIdentity()))
  const [enabled, setEnabled] = useState(() => readShortcutsEnabled(key))
  const labelId = 'settings-single-key-shortcuts'
  const toggle = () => {
    const next = !enabled
    setEnabled(next)
    writeShortcutsEnabled(key, next)
  }
  return (
    <div className="k-card" data-keyboard-card>
      <div className="p-5 flex flex-col gap-4">
        <div>
          <div className="text-13 font-semibold text-ink-primary">{KEYBOARD_CARD_TITLE}</div>
          <div className="text-12 text-ink-muted mt-1">{KEYBOARD_CARD_NOTE}</div>
        </div>
        <div className="flex items-center justify-between border-t border-edge-row pt-4">
          <div>
            <div id={labelId} className="text-13 font-medium text-ink-primary">{SINGLE_KEY_LABEL}</div>
            <div className="text-12 text-ink-muted mt-1">{SINGLE_KEY_HINT}</div>
          </div>
          <button type="button" role="switch" aria-checked={enabled} aria-labelledby={labelId} onClick={toggle}
            className={`relative inline-flex h-5 w-9 flex-shrink-0 rounded-full border-2 border-transparent transition-colors duration-200 ${enabled ? 'bg-accent' : 'bg-ink-disabled'}`}>
            <span className={`pointer-events-none inline-block h-4 w-4 transform rounded-full bg-surface-control transition duration-200 ${enabled ? 'translate-x-4' : 'translate-x-0'}`} />
          </button>
        </div>
      </div>
    </div>
  )
}
